import React, { useEffect } from 'react';
import { FaDownload } from 'react-icons/fa';
import { Typewriter } from 'react-simple-typewriter';
import table from '../../images/lottie-animation/table.json';
import Lottie from 'lottie-react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Wave from 'react-wavify'
import './myIntro.css';
import { useLanguage } from '../../context/LanguageContext';










const MyIntro = () => {


    const handleDone = () => {
        console.log(`Done after 5 loops!`)
    }

    const handleDownloadResume = () => {
        fetch('Fahim-Faysal-Resume.pdf')
            .then(response => {
                response.blob()
                    .then(blob => {
                        // Creating new object of PDF file
                        const fileURL = window.URL.createObjectURL(blob);
                        // Setting various property values
                        let alink = document.createElement('a');
                        alink.href = fileURL;
                        alink.download = 'Fahim-Faysal-Resume.pdf';
                        alink.click();
                    })
            })
    }

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])








    const { language } = useLanguage();

    const translations = {
        english: 'Welcome to my Portfolio. I am a Full Stack Web Developer. I am proficient with JavaScript, React JS, Express JS, Node JS MongoDB, HTML5, CSS3, and CSS frameworks. Also, I have a firm knowledge of using React Router, React Query, Redux Toolkit, RTK Query, Firebase, cPanel. <br /> I love creating user friendly websites with focus on simple, clean and effective UI/UX philosophy. With these blueprints in mind I work with vision and goals to optimize the features in websites.',
        bangla: 'আমার পোর্টফোলিওতে স্বাগতম। আমি একজন ফুল স্ট্যাক ওয়েব ডেভেলপার। আমি JavaScript, React JS, Express JS, Node JS MongoDB, HTML5, CSS3 এবং CSS ফ্রেমওয়ার্কের সাথে দক্ষ। এছাড়াও, রিঅ্যাক্ট রাউটার, রিঅ্যাক্ট ক্যোয়ারী, রেডাক্স টুলকিট, আরটিকে কোয়েরি, ফায়ারবেস, সিপ্যানেল ব্যবহার করার বিষয়ে আমার দৃঢ় জ্ঞান আছে ৷ <br /> আমি সহজ, পরিষ্কার এবং কার্যকর UI/UX দর্শনের উপর ফোকাস দিয়ে ব্যবহারকারী বান্ধব ওয়েবসাইট তৈরি করতে পছন্দ করি। এই ব্লুপ্রিন্টগুলিকে মাথায় রেখে আমি ওয়েবসাইটগুলির বৈশিষ্ট্যগুলিকে অপ্টিমাইজ করার জন্য দৃষ্টি এবং লক্ষ্য নিয়ে কাজ করি ৷',
    };
    const paragraphs = translations[language].split('<br />').map((paragraph, index) => (
        <p className='text-lg mb-4' key={index}>{paragraph}</p>
    ));



    const translations2 = {
        english: 'Hi, This Is Fahim Faysal',
        bangla: 'হাই, আমি ফাহিম  ফয়সাল',
    };











    return (



        <div className='mt-10 lg:mt-0 mb-28 mx-auto' id='about'>

            <div className='flex justify-center items-center flex-col-reverse sm:flex-col-reverse md:flex-col-reverse lg:flex-row lg:mx-0 md:mx-0 sm:mx-0 mx-0  md:gap-x-6 sm:gap-x-0 gap-x-0'>

                <div className=' lg:w-full md:w-3/4 sm:w-11/12 w-11/12 lg:ml-16 md:ml-0 sm:ml-0 ml-0'>

                    {/* <h1 className='text-[22px] sm:text-[22px] md:text-[39px] lg:text-5xl text-amber-500 lg:-mt-2 md:mt-12 sm:mt-12 mt-2 mb-4 font-mono hidden md:block'> Hi! This is Fahim Faysal</h1> */}

                    <h1 className=' text-[22px] sm:text-[22px] md:text-[39px] lg:text-5xl text-amber-500 lg:-mt-2 md:mt-12 sm:mt-12 mt-2 mb-4 font-mono hidden md:block'>{translations2[language]}</h1>

                    {
                        language === 'english' ?
                            <h1 className='md:text-5xl text-[30px] text-amber-500 lg:-mt-2 md:mt-12 sm:mt-12 mt-8 mb-4 font-mono md:hidden block '>I Am Fahim Faysal</h1>
                            :
                            <h1 className='md:text-5xl text-[32px] text-amber-500 lg:-mt-2 md:mt-12 sm:mt-12 mt-8 mb-4 font-mono md:hidden block '>আমি ফাহিম ফয়সাল</h1>
                    }

                    {/* <h1 className='text-[25px] sm:text-[25px] md:text-[38px] lg:text-5xl text-amber-500 lg:-mt-2 md:mt-12 sm:mt-12 mt-2 mb-4 font-mono md:hidden block '> Hi! I Am Fahim Faysal</h1> */}


                    <p className='text-[24px] sm:text-3xl md:text-[40px] lg:text-4xl my-4 text-sky-400 font-mono'>
                        {' '}
                        <Typewriter
                            words={[
                                'Web Developer',
                                'Based On MERN Stack',
                                'Skilled In Node JS',
                                'Good With MongoDB',
                                'Familiar with Redux',
                                'Exploring Next JS',
                                'Quick Learner',
                                'Hard Working...'
                            ]}
                            loop={500}
                            cursor
                            cursorStyle='|'
                            typeSpeed={100}
                            deleteSpeed={50}
                            delaySpeed={1000}
                            onLoopDone={handleDone}
                        />
                    </p>


                    {/* <div className='lg:w-[720px] md:w-full sm:w-[330px] w-[330px] '>
                        <p className='text-lg mb-4 text-justify '>Welcome to my Portfolio. I am a Full Stack Web Developer. I am proficient with JavaScript, React JS, Express JS, Node JS MongoDB, HTML5, CSS3, and CSS frameworks. Also, I have a firm knowledge of using React Router, React Query, Redux Toolkit, RTK Query, Firebase, cPanel </p>
                    </div>

                    <div className='lg:w-[720px] md:w-full sm:w-[330px] w-[330px]'>
                        <p className='mb-4 text-lg text-justify'> I love creating user friendly websites with focus on simple, clean and effective UI/UX philosophy. With these blueprints in mind I work with vision and goals to optimize the features in websites</p>
                    </div> */}

                    <div className='lg:w-[720px] md:w-full sm:w-[330px] w-[330px] '>
                        <p className='mb-4 text-lg text-justify'>{paragraphs}</p>
                    </div>



                    <div onClick={handleDownloadResume} className='animation ' data-aos="fade-right">
                        <button className='color-changing-download-resume-button  cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-4 py-2 rounded-sm  text-white text-lg mt-3 border-0 ' title='Download Resume'>
                            <div className='flex justify-center items-center gap-x-2'>
                                <FaDownload className='text-white text-xl'></FaDownload>
                                {
                                    language === 'english' ?
                                        <h1>Download Resume</h1>
                                        :
                                        <h1 className='md:text-[16px] text-[15px]'>ডাউনলোড জীবনবৃত্তান্ত</h1>
                                }
                            </div>
                        </button>
                    </div>

                </div>

                <div className='lg:w-3/4 md:w-3/4 sm:w-full w-full'>
                    {/* <img src={table} alt="myself" className='rounded-xl lg:w-3/4 md:w-full sm:w-[330px] w-[330px] lg:ml-32 lg:h-[550px] md:h-[550px] sm:h-[450px] h-[450px]' /> */}
                    <Lottie
                        animationData={table}
                        loop={true}
                    ></Lottie>
                </div>

            </div>



            <Wave className=' lg:-mt-6 md:-mt-1 -mt-2' mask="url(#mask)" fill="#650c7b " >
                <defs>
                    <linearGradient id="gradient" gradientTransform="rotate(90)">
                        <stop offset="0" stopColor="white" />
                        <stop offset="0.5" stopColor="black" />
                    </linearGradient>
                    <mask id="mask">
                        <rect x="0" y="0" width="2200" height="170" fill="url(#gradient)" />
                    </mask>
                </defs>
            </Wave>


        </div>
    );
};

export default MyIntro;